/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ExpectationsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');
    let progressionType = ProgressionType.PROGRESSION;

    return hash({
      group,
      subjects: this.store.query('goals/subject', { trackable: true }),
      milestones: this.store.query('milestones/milestone', { progressionType }),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = model.subjects
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }
  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('group/expectations').set('selectedMilestoneSet', null);
  }
}
